// @ts-ignore
export const BATCH_COLORS = [
    'rgb(231,91,91)',   // Rosso
    'rgb(63,147,249)',  // Blu
    'rgb(13,148,136)',  // Verde acqua
    'rgb(93,213,82)',   // Verde chiaro
    'rgb(242,167,67)',  // Arancione
    '#4ABCC8',          // Azzurro
    'rgb(153,102,255)', // Viola
    'rgb(255,206,86)',  // Giallo
    'rgb(75,192,192)',  // Verde Tiffany
    'rgb(255,159,64)'   // Arancione scuro
];




export function numberWithCommas(x) {
    if (x) {

        return x.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' €';
    }
    return 0;
}
